import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactPaginate from 'react-paginate';
import queryString from 'query-string';

import Spinner from '../../components/generics/Spinner';
import Filter from '../../components/generics/Filter';
import ListCallbackHeader from '../../components/orders/ListCallbackHeader';

import Alert from "../../utils/Alert";
import Modal from "../../components/generics/Modal";

import { STARTING_PAGE } from '../../constants/constants';

import { isPlantUser, isDeliveryUser, getUserData } from '../../utils/AuthService';
import { orderStatusOptions } from '../../utils/Helpers';

import {
  fetchOrders,
  fetchOrdersSuccess,
  fetchOrdersFailure,
  createOrder,
  createOrderSuccess,
  createOrderFailure,
} from "../../store/orders/actions";

import { getProductionList, deleteMarketOrder, changeMarketOrderStatusFromReceivedToShipped } from "../../store/orders/api";
import {
  fetchDestinations,
  fetchDestinationsSuccess,
  fetchDestinationsFailure,
  createShipmentForOrder,
  createShipmentForOrderSuccess,
  createShipmentForOrderFailure,
} from "../../store/shipments/actions";

import MarketOrderList from '../../components/orders/MarketOrderList'
import { withRouter } from "utils/WithRouter";

export class OrderListContainer extends Component {
  constructor(props){
    super(props);

    this.state = {
      page: 1,
      orderId: '',
      date: '',
      status: undefined,
      market: undefined,
      loadingProdList: false,
      openDeleteModal: false,
      orderToDelete: undefined,
    };

    this.alertRef = React.createRef();
  }

  componentDidMount() {
    this.props.fetchMarkets();

    const params = queryString.parse(this.props.location.search);
    const page = params.page ? params.page : STARTING_PAGE;
    const date = params.date ? params.date : '';
    const market = params.market ? params.market : undefined;
    const orderId = params.orderId ? params.orderId : undefined;
    const status = params.status ? params.status : undefined;

    this.setState({ page, orderId, market, date, status }, () => {
      this.props.fetchMarketOrders(page, orderId, market, status, date, isPlantUser());
    });
  }

  // ---------------------------------------------------------------------------
  // Filters
  // ---------------------------------------------------------------------------
  onOrderIdChanged = (event) => {
    const orderId = event.target.value ? event.target.value : '';
    this.setState({ orderId, page: STARTING_PAGE }, () => {
      this.filterList();
    });
  }

  onDateChange = (event) => {
    const date = event.target.value ? event.target.value : '';
    this.setState({ date, page: STARTING_PAGE }, () => {
      this.filterList();
    });
  }

  onStatusChange = (event) => {
    const status = event.target.value && event.target.value > -1 ? event.target.value : undefined;
    this.setState({ status, page: STARTING_PAGE }, () => {
      this.filterList();
    });
  }

  onMarketChange = (event) => {
    const market = event.target.value && event.target.value > -1 ? event.target.value : undefined;
    this.setState({ market, page: STARTING_PAGE }, () => {
      this.filterList();
    });
  }

  filterList = () => {
    let params = {};
    params.page = this.state.page;

    if (this.state.orderId){
      params.orderId = this.state.orderId;
    }
    if (this.state.date){
      params.date = this.state.date;
    }
    if (this.state.status){
      params.status = this.state.status;
    }
    if (this.state.market){
      params.market = this.state.market;
    }
    this.props.history.push({
      search: queryString.stringify(params)
    });
    this.props.fetchMarketOrders(
      this.state.page,
      this.state.orderId,
      this.state.market,
      this.state.status,
      this.state.date,
      isPlantUser()
    );
  }

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if(page !== this.state.page){
      this.setState({ page }, () => {
          this.filterList();
      });
    };
  };

  // ---------------------------------------------------------------------------
  // Create new Order
  // ---------------------------------------------------------------------------
  onOrderCreate = () => {
    this.props.createOrder(this.props);
  };

  // ---------------------------------------------------------------------------
  // Go to Shipment
  // ---------------------------------------------------------------------------
  onShipmentClick = (id, shipment) => {
    if (shipment !== null) {
      this.props.history.push(`/shipment/${shipment}/edit`);
    } else {
      this.props.createShipment(id, this.props);
    }
  };

  setPrint () {
    this.contentWindow.__container__ = this;
    this.contentWindow.onbeforeunload = () => document.body.removeChild(this.__container__);
    this.contentWindow.onafterprint = () => document.body.removeChild(this.__container__);
    this.contentWindow.focus(); // Required for IE
    this.contentWindow.print();
  };

  printProductionList = () => {
    this.setState({
        loadingProdList: true,
    })
    getProductionList().then((r) => {
      let blob = new Blob([r.data], { type: 'application/pdf' })
      const oHideFrame = document.createElement("iframe");
      oHideFrame.style.display = "none";
      oHideFrame.onload = this.setPrint;
      oHideFrame.src = window.URL.createObjectURL(blob);
      document.body.appendChild(oHideFrame);

      this.setState({
        loadingProdList: false,
      })
    }).catch((err) => {
      console.log(err);
      this.setState({
        loadingProdList: false,
      })
    });
  };

  // ---------------------------------------------------------------------------
  // Delete Market Order
  // ---------------------------------------------------------------------------
  handleDeleteModal = (orderId) => {
    this.setState({ orderToDelete: orderId });
    this.setState({ openDeleteModal: true });
  };

  handleDelete = (orderId) => {
    deleteMarketOrder(orderId).then(
      () => {
        this.alertRef.current.sendAlert(`Market Order #${orderId} has been deleted successfully`, "success");
        // Refresh Market Order List
        this.props.fetchMarketOrders(
          this.state.page,
          this.state.orderId,
          this.state.market,
          this.state.status,
          this.state.date,
          isPlantUser()
        );
      },
      () => {
        this.alertRef.current.sendAlert(`Market Order #${orderId} couldn't be deleted`);
      }
    );
    this.setState({ openDeleteModal: false });
  };

  changeStatusFromReceivedToShipped = (orderId) => {
    changeMarketOrderStatusFromReceivedToShipped(orderId)
      .then(() => {
        this.alertRef.current.sendAlert(`Market Order #${orderId} status changed to Shipped.`, "success");
        this.props.history.push(`/orders/${orderId}`);
      })
      .catch(() => {
        this.alertRef.current.sendAlert(`Market Order #${orderId} status couldn't be changed.`);
      });
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    const isPlantUserValue = isPlantUser();
    const isDeliveryUserValue = isDeliveryUser();
    const userData = getUserData();
    const deliveryUserMarkets = userData ? userData.markets : [];
    const { loadingProdList } = this.state;
    if(!this.props.orderList.orders){
      return(
        <Spinner />
      )
    }
    return (
      <div className="animated fadeIn">
        <Alert ref={this.alertRef} />
        <div className="card">
          {!isDeliveryUserValue &&
            <ListCallbackHeader
              title="Orders"
              iconClass="fa fa-file-text-o mr-05"
              onActionClick={!isPlantUserValue ? this.onOrderCreate : this.printProductionList}
              btnIcon={!isPlantUserValue ? "fa-plus" : "fa-print"}
              btnText={!isPlantUserValue ? "" : "Print Production List"}
              isLoading={loadingProdList}
            />
          }
          <Filter
            searchLabel="Order ID"
            searchPlaceholder="Order ID"
            searchVal={this.state.orderId}
            onSearchChange={this.onOrderIdChanged}
            dateLabel={!isPlantUserValue ? 'Delivery Date' : 'Date received'}
            dateVal={this.state.date}
            onDateChange={this.onDateChange}
            dropdownLabel={!isDeliveryUserValue && "Status"}
            dropdownPlaceholder="Select order status"
            dropdownVal={this.state.status}
            onDropdownChange={this.onStatusChange}
            dropdownByElementId
            dropdownOptions={orderStatusOptions}
            dropdownLabel2={(isPlantUserValue || isDeliveryUserValue) && "Market"}
            dropdownPlaceholder2="Select market"
            dropdownVal2={this.state.market}
            onDropdownChange2={this.onMarketChange}
            dropdownByElementId2
            dropdownOptions2={!isDeliveryUserValue ? (this.props.marketsList ? this.props.marketsList.destinations : []) : deliveryUserMarkets}
            colClass={isPlantUserValue && "col-12 col-sm-3"}
          />
        </div>
        <div className="card">
          <div className="card-block p-0">
            <table className="table table-striped table-bordered datatable mb-0">
              <thead>
                <tr>
                  <th className={(isPlantUserValue || isDeliveryUserValue) && "hidden-xs-down"}>ID</th>
                  {(isPlantUserValue || isDeliveryUserValue) && <th>Market</th>}
                  <th>{isPlantUserValue ? 'Date Received' : 'Delivery Date'}</th>
                  {!isPlantUserValue && <th className="hidden-xs-down">Shipment Date</th>}
                  <th className="hidden-xs-down">
                    {isPlantUserValue ? 'Delivery Date' : 'Num Items'}
                  </th>
                  {!isDeliveryUserValue && <th className={isPlantUserValue && "hidden-xs-down"}>Status</th>}
                  {!isDeliveryUserValue && <th className="hidden-xs-down">Created by</th>}
                  <th>Actions</th>
                </tr>
              </thead>
              <Modal
                closeModal={() => this.setState({ openDeleteModal: false })}
                isModalOpen={this.state.openDeleteModal}
                onConfirm={() => this.handleDelete(this.state.orderToDelete)}
                onCancel={() => this.setState({ openDeleteModal: false })}
                header="Delete Market Order"
                content={`Are you sure you want to delete Market Order #${this.state.orderToDelete}?`}
                onConfirmButtonText="Yes"
                onCancelButtonText="No"
              />
              <MarketOrderList
                isPlantUser={isPlantUserValue}
                isDeliveryUser={isDeliveryUserValue}
                orders={this.props.orderList.orders}
                orderStatusOptions={orderStatusOptions}
                onShipmentClick={this.onShipmentClick}
                handleDelete={this.handleDeleteModal}
                changeStatusFromReceivedToShipped={this.changeStatusFromReceivedToShipped}
              />
            </table>
            {this.props.orderList.pages > 1 &&
              <ReactPaginate pageCount={this.props.orderList.pages}
                             pageRangeDisplayed={2}
                             marginPagesDisplayed={1}
                             previousLabel="<"
                             nextLabel=">"
                             onPageChange={this.handlePageRequest}
                             initialPage={this.state.page-1}
                             disableInitialCallback={true}
                             containerClassName="pagination"
                             pageClassName="page-item"
                             pageLinkClassName="page-link"
                             activeClassName="page-item active"
                             previousClassName="paginate_button previous"
                             nextClassName="paginate_button next"
                             disabledClassName="page-item disabled"
                             forcePage={this.state.page-1}/>
            }
          </div>
        </div>
        {this.props.orderList.loading ?
          <Spinner />
        :
          null
        }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    orderList: state.orders.marketOrdersList,
    marketsList: state.shipments.destinationsList
  };
};

const mapDispatchToProps = (dispatch) => {
  const finished = (data, props) => {
    props.history.push(`/orders/${data.id}`)
  }
  const goToShipment = (id, props) => {
    props.history.push(`/shipment/${id}/edit`);
  }
  return {
    fetchMarketOrders: (page, orderId, market, status, date, marketUser) => {
      dispatch(fetchOrders(page, orderId, market, status, date, marketUser)).payload.then((response) => {
        dispatch(fetchOrdersSuccess(response.data))
      }, (error) => {
        dispatch(fetchOrdersFailure(error));
      });
    },
    fetchMarkets: () => {
      dispatch(fetchDestinations()).payload.then((response) => {
        dispatch(fetchDestinationsSuccess(response.data));
      }, (error) => {
        dispatch(fetchDestinationsFailure(error));
      });
    },
    createOrder: (props) => {
      dispatch(createOrder()).payload.then((response) => {
        finished(response.data, props)
        dispatch(createOrderSuccess(response.data))
      }, (error) => {
        dispatch(createOrderFailure(error));
      });
    },
    createShipment: (id, props) => {
      dispatch(createShipmentForOrder(id)).payload.then((response) => {
        dispatch(createShipmentForOrderSuccess(response.data))
        goToShipment(response.data.id, props);
      }, (error) => {
        dispatch(createShipmentForOrderFailure(error));
      })
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OrderListContainer));
